module.exports = __webpack_public_path__ + "static/media/login-background-cement-1920@2x.5d3d62ad.png";